<div class="page-sub-title">Sign In</div>

<div class="padded-container login-form margin-top-large">
  <p>
    <label for="username">Username</label>
    <input
      id="username"
      type="text"
      class="input full-width"
      placeholder="Username"
      [(ngModel)]="username"
      autocapitalize="none"
    />
  </p>

  <p class="margin-top-large">
    <label for="password">Password</label>
    <input
      id="password"
      type="password"
      class="input full-width"
      placeholder="Password"
      [(ngModel)]="password"
      autocapitalize="none"
    />
  </p>

  <p>
    <button class="btn btn-green btn-full-width margin-top-large" (click)="loginClicked()">
      Login
    </button>
  </p>

  <div class="critical" *ngIf="isInvalidLogin">
    <p>Invalid username or password.</p>
  </div>
</div>
